if (!customElements.get('slim-trust-icons')) {
  customElements.define(
    'slim-trust-icons',
    class SlimTrustIcons extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        if (document.readyState != 'complete') {
          document.addEventListener('DOMContentLoaded', () => this.initOrDestroyCarousel());
        } else {
          this.initOrDestroyCarousel();
        }

        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      handleResize() {
        this.initOrDestroyCarousel();
      }

      initOrDestroyCarousel() {
        const isSmallScreen = window.innerWidth < 768;
        const swiperContainer = this.querySelector('.swiper-container');

        if (!swiperContainer) {
          // console.error('Swiper container not found in popular-categories component.');
          return;
        }

        if (isSmallScreen && !this.swiper) {
          if (this.isLoadingSwiper) return;
          this.isLoadingSwiper = true;
          // INIT
          const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
          const bannerInterval = swiperWrapper.getAttribute('data-interval') || 5000;
          const bannerSpeed = swiperWrapper.getAttribute('data-transition') || 1500;

          window.luxoRunNearElement(swiperContainer, () => {
            window.luxoLoadSwiper().then(() => {
              if (window.innerWidth >= 768 || this.swiper) {
                this.isLoadingSwiper = false;
                return;
              }

              this.swiper = new Swiper(swiperContainer, {
                slidesPerView: 2,
                spaceBetween: 0,
                loop: false,
                autoplay: {
                  delay: bannerInterval,
                  disableOnInteraction: false,
                },
                speed: bannerSpeed
              });
              this.isLoadingSwiper = false;
            });
          });
        } else if (!isSmallScreen && this.swiper) {
          // DESTROY
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
